import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useSiteCustomPreferences} from '../../../hooks/use-site-custom-preferences'
import TAContentSlot from '../../../components/content-slot/think-anlytics-slot'
import {pdProductCarousalStyles} from '../../../theme/components/project/pdpage-product-recommendation-styles'

export const ThinkAnalytics = ({
    calloutMsg,
    count,
    useCase,
    filterOne,
    filterOneValue,
    filterTwo,
    filterTwoValue,
    isPLPSlot
}) => {
    const contentSlot = {
        jsx: {
            useCase: useCase ?? '',
            isPLPSlot: isPLPSlot ?? false,
            filterOne: filterOne ?? '',
            filterOneValue: filterOneValue ?? '',
            filterTwo: filterTwo ?? '',
            filterTwoValue: filterTwoValue ?? '',
            count: count ?? ''
        }
    }
    const {getcustomPreferencevalue} = useSiteCustomPreferences()
    const isTAEnabled = getcustomPreferencevalue('pwaThinkAnalyticsEnabled')
    if (!isTAEnabled) return null
    return (
        <Box sx={pdProductCarousalStyles}>
            <Box position="relative" pb={6} className="pd-product-carousal-container">
                <TAContentSlot
                    title={calloutMsg}
                    enableFavourite={true}
                    contentSlot={contentSlot}
                />
            </Box>
        </Box>
    )
}

ThinkAnalytics.propTypes = {
    calloutMsg: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    useCase: PropTypes.string,
    filterOne: PropTypes.string,
    filterOneValue: PropTypes.string,
    filterTwo: PropTypes.string,
    filterTwoValue: PropTypes.string,
    isPLPSlot: PropTypes.bool
}

export default ThinkAnalytics
